export const reviewersInitialState = {
    reviewers: null,
    isLoading: true,
    pagination: null,
}